export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.rn_drpet';

export const APP_STORE_URL = 'https://apps.apple.com/kr/app/id1516235091';

export const GOOGLE_PLAY_ICON_NAME = 'mdi:google-play';

export const APP_STORE_ICON_NAME = 'ci:apple';
